<template>
  <div
    class="relative flex h-12 w-full items-center justify-center gap-2 rounded-t-xl bg-slate-900 pr-1.5 pl-3.5 text-[13px] text-[#e0def4] shadow-popover lg:rounded-xl dark:border dark:border-[#524f67]">
    <slot />
  </div>
</template>
